import { AccordionDetails, styled } from "@mui/material";

export const CustomizeAccordionDetails = styled(AccordionDetails)({});
